module.exports = __webpack_public_path__ + "static/media/penetrating_arrows.d526ad5d.png";